/**
 * Transfer Slice - Manages transfer flow state
 *
 * Centralizes the transfer UI state that was previously local to useSoftphoneTransfer:
 * - Current step (search / confirmation)
 * - Selected target and phone number
 * - Transfer execution status
 * - Transfer type (blind / warm / voicemail)
 */

import type { TransferSlice, TransferSliceState } from './index.types';
import type { SoftphoneStore } from 'Modules/softphone/store';
import { StateCreator } from 'zustand';

export * from './index.types';

const initialState: TransferSliceState = {
  transferStep: 'search',
  transferTarget: null,
  transferSelectedPhoneNumber: null,
  isTransferring: false,
  transferType: 'blind',
  searchTerm: '',
};

export const createTransferSlice: StateCreator<
  SoftphoneStore,
  [],
  [],
  TransferSlice
> = (set) => ({
  ...initialState,

  setTransferStep: (step) => set({ transferStep: step }),

  setTransferTarget: (target) => set({ transferTarget: target }),

  setTransferSelectedPhoneNumber: (phoneNumber) =>
    set({ transferSelectedPhoneNumber: phoneNumber }),

  setIsTransferring: (isTransferring) => set({ isTransferring }),

  setTransferType: (type) => set({ transferType: type }),

  setSearchTerm: (term) => set({ searchTerm: term }),

  resetTransferFlow: () => set(initialState),
});
